import React, { useMemo } from 'react';
import DENTModalOverviewGeneralSection from '../DENTModalOverviewGeneralSection/DENTModalOverviewGeneralSection';
import styles from './DENTModalOverviewGeneralPeriodontal.module.scss';
import LinkButtonWithIcon from '../../../../Components/Button/LinkButtonWithIcon';
import { Position } from '../../../Base/Enums/Position.enum';
import { getSideDependingPeriodontalObject } from '../../Helpers/periodontal/getSideDependingPeriodontalObject';
import DENTModalOverviewPeriodontalItemDetail from '../DENTModalOverviewPeriodontalItem/DENTModalOverviewPeriodontalItemDetail';
import { ToothDetailContentType } from '../../Enums/ToothDetailContentType.enum';
import { useDENTContext } from '../../Services/DENTContext';
import { PeriodontalSurface } from '../../Interfaces/PeriodontalObject.interface';
import { setLastPeriodontalToothForOpening } from '../../Hooks/Tooth/Periodontal/usePeriodontalKeyboard';

interface Props {
	onChangeContentType: (type: ToothDetailContentType) => void;
}

const DENTModalOverviewGeneralPeriodontal = ({
	onChangeContentType,
}: Props) => {
	const { activeTooth, setActivePeriodontalItem } = useDENTContext();

	const items = useMemo(
		() =>
			getSideDependingPeriodontalObject(activeTooth?.periodontal, activeTooth),
		[activeTooth],
	);

	const openModal = (type?: PeriodontalSurface) => {
		setActivePeriodontalItem(type || items[0].type);
		if (type != null && activeTooth?.number != null) {
			setLastPeriodontalToothForOpening(activeTooth.number);
		}
		onChangeContentType(ToothDetailContentType.PERIODONTAL);
	};

	return (
		<DENTModalOverviewGeneralSection
			title={'patientTreatment.meddiDENT.dentalCross.periodontal.title'}
			actionButton={
				<LinkButtonWithIcon
					title={
						'patientTreatment.meddiDENT.dentalCross.periodontal.actionTitle'
					}
					icon={'/dist/icons/dent/plus.svg'}
					iconPosition={Position.LEFT}
					onClick={openModal}
				/>
			}>
			<div className={styles.boxes}>
				{items.map(item => {
					if (!item.item) return <></>;

					return (
						<DENTModalOverviewPeriodontalItemDetail
							key={item.title}
							periodontalItem={item.item}
							title={item.title}
							onClick={() => openModal(item.type)}
						/>
					);
				})}
			</div>
		</DENTModalOverviewGeneralSection>
	);
};

export default DENTModalOverviewGeneralPeriodontal;
